import { Component, OnInit, ViewChild } from '@angular/core';
import { Subject, takeUntil } from "rxjs";
import { Message, MessageService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { TranslateService } from "@ngx-translate/core";
import { ExportDataModel } from "../../../models/reservations/export-data.model";
import { ReservationService } from "../../../services/reservations/reservation.service";
import * as moment from "moment";
import * as FileSaver from "file-saver";

@Component({
  selector: 'app-export-reservations-form',
  templateUrl: './export-reservations-form.component.html',
  styleUrls: ['./export-reservations-form.component.scss']
})
export class ExportReservationsFormComponent implements OnInit {

  //#region Fields
  public unsubscribe: Subject<void> = new Subject<void>()
  public exportDataModel: ExportDataModel = new ExportDataModel();
  public errorModel: { [k: string]: any } = {};
  public errorMsg: Message[];
  public spinner = false;
  public dateRange: Date[] = [new Date(), new Date()];
  public requiredFieldErrorMessage = "INFO.REQUIRED_FIELD";
  @ViewChild('rangeCalendar') dateRangePickerControl: any;
  //#endregion

  //#region Constructor
  constructor(
    public ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    public reservationService: ReservationService,
    public messageService: MessageService,
    public translate: TranslateService
  ) {
    if (this.config.data != undefined && this.config.data.venueId) {
      this.exportDataModel.venueId = this.config.data.venueId;
    }
    if (this.config.data != undefined && this.config.data.venueName) {
      this.exportDataModel.venueName = this.config.data.venueName;
    }
  }

  ngOnInit(): void {

  }
  //#endregion

  //#region Public Methods
  public downloadFile(model: ExportDataModel): void {
    this.errorModel = {};
    this.errorMsg = [];

    if (this.dateRange.length < 2 || !this.dateRange[1]) {
      this.errorModel['DateRange'] = this.requiredFieldErrorMessage;
    }

    model.fromDate = moment(this.dateRange[0]).format('yyyy-MM-DDTHH:mm:ss');
    model.toDate = moment(this.dateRange[1]).format('yyyy-MM-DDTHH:mm:ss');

    if (Object.keys(this.errorModel).length === 0) {
      this.spinner = true;
      this.reservationService.downloadExcelFile(model)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe({
          next: (response) => {
            FileSaver.saveAs(response as Blob, 'Reservations_' + model.venueName + '_' + model.fromDate + '_' + model.toDate + '.xls');
            this.spinner = false;
            const summary = this.translate.instant('RESERVATION.EXPORTED');
            this.messageService.add({severity: 'success', summary, life: 3000});
          },
          error: errorResponse => {
            this.spinner = false;
          }
        });
    }
  }

  public sendFileToEmail(model: ExportDataModel): void {
    this.errorModel = {};
    this.errorMsg = [];

    if (this.dateRange.length < 2 || !this.dateRange[1]) {
      this.errorModel['DateRange'] = this.requiredFieldErrorMessage;
    }

    this.exportDataModel.fromDate = moment(this.dateRange[0]).format('yyyy-MM-DDTHH:mm:ss');
    this.exportDataModel.toDate = moment(this.dateRange[1]).format('yyyy-MM-DDTHH:mm:ss');

    if (Object.keys(this.errorModel).length === 0) {
      this.spinner = true;
      this.reservationService.exportExcelToEmail(model)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe({
          next: (response) => {
            this.spinner = false;
            const summary = this.translate.instant('RESERVATION.EXPORTED');
            this.messageService.add({severity: 'success', summary, life: 3000});
          },
          error: errorResponse => {
            this.spinner = false;
          }
        });
    }
  }

  public isRangeDate(date: any, index: number, both: boolean = false): boolean {
    const selected = this.dateRangePickerControl.value && this.dateRangePickerControl.value[index] ? this.dateRangePickerControl.value[index] : null;
    if (selected) {
      const equals = date.day === selected.getDate() && date.year === selected.getFullYear() && date.month === selected.getMonth();

      if (both && equals) {
        return !this.dateRangePickerControl.value[1];
      }

      return equals;
    }
    return false;
  }

  public cancel(): void {
    this.ref.close(false);
  }
  //#endregion
}
